import { useCallback } from "react";
import { usePermissions } from "./usePermissions";

/**
 * Gets a permission checker function.
 * @returns A function which allows you to check whether the current user has all specified permissions.
 */
export function usePermissionChecker(): (permissions: string | ReadonlyArray<string>) => boolean {
  const [shellPermissions] = usePermissions();
  const shellPermissionsSet = new Set(shellPermissions);

  return useCallback((permissions) => {
      if (typeof permissions === "string") return shellPermissionsSet.has(permissions);

      for (const permission of permissions) {
        if (!shellPermissionsSet.has(permission)) return false;
      }

      return true;
    },
    [shellPermissions],
  );
}
